import formatBulkQuantity from '../../../../utils/formatBulkQuantity';

export const isSelectedItem = (bulkSale, offsetIndex, selected) =>
  (bulkSale ? formatBulkQuantity(offsetIndex) : offsetIndex) === selected;
